import mainScript from './components/main/script'
import ga from './ljs/ga'
ga()
mainScript()